import { getRuntimeConfig } from './runtimeConfig';

const config = getRuntimeConfig();

export const oidcConfig = {
  authority: config.OIDC_AUTHORITY || `https://login.microsoftonline.com/${config.AZURE_TENANT_ID || 'common'}/v2.0`,
  client_id: config.AZURE_CLIENT_ID || '',
  redirect_uri: config.REDIRECT_URI || window.location.origin,
  scope: 'openid email profile',
  automaticSilentRenew: true,
};
